var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestricticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.33398V8.00065M10.5 11.3423L10.5083 11.3332",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.4083V4.66667C3 4.22464 3.17559 3.80072 3.48816 3.48816C3.80072 3.17559 4.22464 3 4.66667 3H16.3333C16.7754 3 17.1993 3.17559 17.5118 3.48816C17.8244 3.80072 18 4.22464 18 4.66667V13C18 13.442 17.8244 13.8659 17.5118 14.1785C17.1993 14.4911 16.7754 14.6667 16.3333 14.6667H7.13417C6.88436 14.6667 6.63776 14.7229 6.41259 14.8311C6.18743 14.9392 5.98946 15.0967 5.83333 15.2917L3.89083 17.72C3.82619 17.801 3.73797 17.8599 3.63837 17.8886C3.53877 17.9173 3.43272 17.9143 3.33488 17.8801C3.23705 17.8459 3.15227 17.7821 3.09228 17.6976C3.03228 17.6131 3.00004 17.512 3 17.4083Z",
    stroke: "#667085",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestricticon);
export default __webpack_public_path__ + "static/media/restricticon.dd22233c388e13ab8439aaa6808c57bb.svg";
export { ForwardRef as ReactComponent };